import { OrderLine } from "../entities/app-data/Transaction";

const getSpentTokens = (orderLines) => {
  var spentTokens = [];
  orderLines.forEach((orderLine) => {
    if (orderLine.tokenTransaction) {
      var sameToken = spentTokens.find((token) => {
        return token.token === orderLine.tokenTransaction.token;
      });
      if (sameToken) {
        sameToken.amount += orderLine.tokenTransaction.amount;
      } else {
        spentTokens.push({
          token: orderLine.tokenTransaction.token,
          amount: orderLine.tokenTransaction.amount,
        });
      }
    }
  });
  return spentTokens;
};
const getOrderLines = (transaction, products, tokens) => {
  return transaction.order_details.map((orderLine) => {
    var product = products.find((product) => {
      return product.id === orderLine.product_id;
    });

    if (orderLine.paid.tokens) {
      orderLine.paid.tokens.map((token) => {
        var tokenPaid = null;
        tokenPaid = tokens.find((t) => {
          return (t.id = token.id);
        });
        if (tokenPaid === null) {
          tokenPaid = {
            name: "ID " + token.id,
            icon: "local_play",
            id: token.id,
          };
        }
        token.token = tokenPaid;
      });
    }
    return new OrderLine(orderLine, product);
  });
};

export { getSpentTokens, getOrderLines };
